import { useNavigate } from 'react-router-dom';
import { articleCards } from '@/mocks/articles';

export default function ArticleCards() {
  const navigate = useNavigate();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-3">
            Sugargoo Spreadsheet Guides & Resources
          </h2>
          <p className="text-foreground-600 text-base max-w-xl mx-auto">
            Explore our in-depth SEO guides covering everything from product discovery and shipping costs to expert reviews and beginner tips.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {articleCards.map((article) => (
            <button
              key={article.slug}
              onClick={() => {
                navigate(`/${article.slug}`);
                window.scrollTo({ top: 0, behavior: 'instant' });
              }}
              className="group flex flex-col bg-background-50 rounded-xl border border-background-200/60 overflow-hidden text-left transition-all duration-200 hover:shadow-sm cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageSrc}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="text-base font-heading font-semibold text-foreground-900 mb-2 leading-snug group-hover:text-primary-500 transition-colors duration-200 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 flex-1 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-time-line"></i></span>
                    {article.readTime}
                  </span>
                  <span className="flex items-center gap-1 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors duration-200">
                    Read Article
                    <span className="w-3 h-3 flex items-center justify-center"><i className="ri-arrow-right-line"></i></span>
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}